<!-- END TEMPORARY MAINTENANCE BANNER — retain router-outlet when removing. -->
<router-outlet></router-outlet>
<!-- TEMPORARY MAINTENANCE BANNER — Home, Crosstab and Brand Analysis only. -->
<div class="maintenance-layout" [class.maintenance-layout--enabled]="isMaintenanceBannerVisible">
  <aside *ngIf="isMaintenanceBannerVisible" class="maintenance-banner" aria-label="Scheduled production downtime">
    <span class="maintenance-banner__message">
      ⚠️ <strong>Scheduled Production Downtime</strong> The PROD server will be unavailable on
      <strong>4 November 2026, from 9:00 AM to 5:00 PM IST</strong> due to a scheduled deployment.
    </span>
    <button type="button" class="maintenance-banner__close" aria-label="Dismiss maintenance notice"
      (click)="maintenanceBannerDismissed = true">
      <span aria-hidden="true">&times;</span>
    </button>
  </aside>
  <div class="maintenance-page-content">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- END TEMPORARY MAINTENANCE BANNER — retain router-outlet when removing. -->

<app-loader></app-loader>
<app-error-alert-popup></app-error-alert-popup>
<app-error-alert-popup-ctba></app-error-alert-popup-ctba>
<app-toast></app-toast>

<!-- Global SVG Definitions -->
<svg width="0" height="0" style="position:absolute; width:0; height:0;">
  <defs>
    <linearGradient id="askme-gradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#8600CD" />
      <stop offset="100%" stop-color="#1110EB" />
    </linearGradient>
  </defs>
</svg>
